import { useCallback, useEffect, useState } from 'react';

export function useFullscreen() {
  const [active, setActive] = useState<boolean>(
    typeof document !== 'undefined' && !!document.fullscreenElement,
  );

  useEffect(() => {
    function onChange() {
      setActive(!!document.fullscreenElement);
    }
    document.addEventListener('fullscreenchange', onChange);
    return () => document.removeEventListener('fullscreenchange', onChange);
  }, []);

  const enter = useCallback(async (element?: Element) => {
    const target = element ?? document.documentElement;
    if (!document.fullscreenElement && target.requestFullscreen) {
      try {
        await target.requestFullscreen();
      } catch {
        // ignore: utente ha negato o browser non supporta
      }
    }
  }, []);

  const exit = useCallback(async () => {
    if (document.fullscreenElement) {
      try {
        await document.exitFullscreen();
      } catch {
        // ignore
      }
    }
  }, []);

  return { active, enter, exit };
}
